import {
  Divider,
  Image,
  Reels,
  Smile,
  VideoCamera,
} from '@wix/wix-ui-icons-common';
import React from 'react';

import { classes } from './Icons.st.css';

export const IconsDesktop = () => (
  <div className={classes.footer}>
    <Image className={classes.icon} />
    <Divider className={classes.icon} />
    <VideoCamera className={classes.icon} />
    <Reels className={classes.icon} />
    <Smile className={classes.icon} />
  </div>
);
